import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Equipment, Filters } from '../types/equipment';
import { useEquipments } from '@hooks';
import { CategoryFilter, EquipmentCard, SearchFilters } from '@components';


const SearchPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [selectedCategory, setSelectedCategory] = useState(searchParams.get('category') || 'all');
  const [filters, setFilters] = useState({
    priceRange: [0, 500],
  });

  // Hooks para obtener equipos y categorías
  const { equipments, loading: loadingEquipments } = useEquipments();

  // Filtrado de equipos
  const filteredEquipment = equipments.filter((item: Equipment) => {
    // Filtro por categoría
    if (selectedCategory !== 'all' && item.categoryId !== selectedCategory) return false;
    // Filtro por rango de precio
    if (item.pricePerDay < filters.priceRange[0] || item.pricePerDay > filters.priceRange[1]) return false;
    return true;
  });

  const handleCategoryChange = (category: string) => {
    setSelectedCategory(category);
  };

  const handleFilterChange = (newFilters: Filters) => {
    setFilters(newFilters);
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Sticky filters bar */}
      <div className="sticky top-16 z-20 bg-white border-b border-gray-200 shadow-sm">
        <div className="container mx-auto flex flex-col items-center">
          <CategoryFilter
            selectedCategory={selectedCategory}
            onCategoryChange={handleCategoryChange}
            color="blue"
          />
          <SearchFilters onFilterChange={handleFilterChange} />
        </div>
      </div>

      {/* Main content */}
      <div className="container mx-auto px-4 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-800">
            Equipos de Rehabilitación
          </h1>
          <p className="text-gray-600 mt-1">
            {filteredEquipment.length} {filteredEquipment.length === 1 ? 'equipo' : 'equipos'} disponibles
          </p>
        </div>

        {loadingEquipments ? (
          <div className="text-center py-12 text-gray-500">Cargando equipos...</div>
        ) : filteredEquipment.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {filteredEquipment.map((equipment: Equipment) => (
              <EquipmentCard key={equipment.id} equipment={equipment} />
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">No se encontraron equipos</h2>
            <p className="text-gray-600 mb-6">
              No hemos encontrado ningún equipo que coincida con tus criterios. Prueba a ajustar los filtros o busca otra cosa.
            </p>
            <button
              onClick={() => {
                setSelectedCategory('all');
                setFilters({
                  priceRange: [0, 500],
                });
              }}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
            >
              Limpiar filtros
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchPage;